<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span class="vms-icon-action" v-bind="attrs" v-on="on">
        <v-btn
          :color="color"
          class="mx-1"
          fab
          x-small
          dark
          elevation="0"
          :disabled="disabled"
          v-bind="$attrs"
          @click.stop="$emit('click', $event)"
        >
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </span>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "VmsIconAction",
  inheritAttrs: false,
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    color: { type: String, default: "info" },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.vms-icon-action {
  display: inline-flex;
  vertical-align: middle;
  line-height: 0;
}
</style>
